import React, { useEffect, useState } from "react";
import { useAuth } from "../authv2/authClient";
import ComponentMap from "../../atom/componentmap";
import ThemedButton from "../../atom/ThemedButton/themedButton";
import { activityState } from "../../config/constants";
import Logo from "../../utils/images/logo.png";
import { Store } from "react-notifications-component";
import * as KeyCode from "keycode-js";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { formValidation } from "../../services/utilities";
import LockResetIcon from "@mui/icons-material/LockReset";
import { resetPassword } from "../../services/api.v2";

const Loginv2 = (props: any) => {
  const auth = useAuth();
  const [data, setData] = React.useState<any>([
    {
      name: "username",
      title: "User Name",
      autoFocus: true,
      required: true,
      value: "",
      errormessage: "Please enter a user name.",
    },
    {
      name: "password",
      title: "Password",
      type: "password",
      required: true,
      value: undefined,
      errormessage: "Please enter a valid password.",
    },
  ]);
  const resertPasswordField = [
    {
      name: "email",
      title: "Email Address",
      value: "",
      type: "email",
      required: true,
      id: "reset_email_forgot_password",
      errormessage: "Please enter a valid email.",
    },
  ];

  const [loginStatus, setloginStatus] = useState<
    "login" | "reset" | "resetSuccess"
  >("login");
  const handleResetPassword = (data: any) => {
    resetPassword(data).then((res: any) => {
      if (res.success) {
        setloginStatus("resetSuccess");
      } else {
        Store.addNotification({
          title: "Failed",
          message: "Please try again.",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: false,
          },
        });
      }
    });
  };

  const [resetPasswordData, setRestPasswordData] = useState<any>(
    JSON.parse(JSON.stringify(resertPasswordField))
  );
  console.log("emikstatess", resetPasswordData);
  const handleLogin = (payload: { username: string; password: string }) => {
    auth.tryLogin(payload, (isAuthenticated: any) => {});
  };
  const handleEnter = (e: any) => {
    if (e.keyCode === KeyCode.KEY_RETURN) {
      const result: any = formValidation(data);
      if (result.valiState) {
        handleLogin(result.ObjectData);
      } else {
        Store.addNotification({
          title: "Please Enter Valid Data",
          message: result.msg,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: false,
          },
        });
      }
    }
  };

  const handleCancel = () => {
    setloginStatus("login");
    setRestPasswordData(JSON.parse(JSON.stringify(resertPasswordField)));
  };
  // const [inputRef, setInputFocus] = useFocus()
  useEffect(() => {
    document.addEventListener("keyup", handleEnter, true);
    return () => {
      document.removeEventListener("keyup", handleEnter, true);
    };
  }, []);
  return (
    <div className="h-screen  w-screen flex justify-center bg-[white] items-center">
      <div className="h-[480px] w-[800px] shadow-lg flex rounded-[20px] bg-[white] overflow-hidden">
        <div className="w-[450px] flex justify-center items-center p-[20px] bg-[#293241] text-[white]">
          <div>
            <div className="text-[32px] font-[700] ">Welcome back</div>
            <div className="text-[16px] mt-8">
              You are just a few clicks away from a great meeting experience.
            </div>
            <div className="text-[16px] mt-6">
              Collaborate and work from anywhere.
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center w-[350px] p-[20px]">
          {loginStatus === "login" ? (
            <Login
              data={data}
              setData={setData}
              activityState={activityState}
              handleLogin={handleLogin}
              auth={auth}
              setLoginStatus={setloginStatus}
            />
          ) : loginStatus === "reset" ? (
            <ResetPassword
              activityState={activityState}
              auth={auth}
              handleCancel={handleCancel}
              resetPasswordData={resetPasswordData}
              setResetPasswordData={setRestPasswordData}
              handleResetPassword={handleResetPassword}
            />
          ) : (
            <ResetSuccess
              resetPasswordEmail={resetPasswordData[0]?.value}
              handleCancel={handleCancel}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Loginv2;

interface LoginProps {
  data: any; // Replace `any` with a specific type for `data` if available
  setData: (value: any) => void; // Replace `any` with the type for `data`
  auth: { isAuthenticated: string };
  activityState: typeof activityState;
  handleLogin: (payload: { username: string; password: string }) => void;
  setLoginStatus: (status: "login" | "reset" | "resetSuccess") => void;
}

const Login: React.FC<LoginProps> = ({
  data,
  setData,
  auth,
  activityState,
  handleLogin,
  setLoginStatus,
}) => {
  return (
    <div>
      <img className="h-8 mx-1 mb-8" src={Logo} alt="login" />
      <ComponentMap data={data} setData={setData} />
      <div className="flex justify-between p-2 mt-2">
        <div className="pt-3">
          <span
            onClick={() => setLoginStatus("reset")}
            className="cursor-pointer"
            id="login_forgot_password"
          >
            Forgot Password?
          </span>
        </div>
        <div>
          <ThemedButton
            style={{ border: "1px solid black" }}
            id="Login"
            icon="custom"
            iconComponent={<LockOpenIcon />}
            loading={auth.isAuthenticated === activityState.WAIT}
            click={handleLogin}
            valiData={data}
            change={setData}
            children={"Login"}
            theme={"secondary"}
          />
        </div>
      </div>
    </div>
  );
};

interface ResetSuccessProps {
  handleCancel: () => void;
  resetPasswordEmail: string;
}

const ResetSuccess: React.FC<ResetSuccessProps> = ({
  handleCancel,
  resetPasswordEmail,
}) => {
  return (
    <div>
      <div className="text-[16px] font-[700]">Password Reset</div>
      <div className="text-md my-3">
        An email has been sent to{" "}
        <span className="font-semibold">{resetPasswordEmail}</span> with
        instructions for resetting your password.
      </div>
      <div className="flex justify-center p-2 mt-2">
        <ThemedButton
          click={handleCancel}
          children={"Login"}
          theme={"secondary"}
          id={"reset_success_login"}
        />
      </div>
    </div>
  );
};

interface ResetPasswordProps {
  resetPasswordData: any; // Replace `any` with the appropriate type if available
  setResetPasswordData: (value: any) => void; // Replace `any` with the type of resetPasswordData
  auth: { isAuthenticated: string };
  activityState: typeof activityState;
  handleCancel: () => void;
  handleResetPassword: (data: any) => void;
}

const ResetPassword: React.FC<ResetPasswordProps> = ({
  resetPasswordData,
  setResetPasswordData,
  auth,
  activityState,
  handleCancel,
  handleResetPassword,
}) => {
  return (
    <div className="flex flex-col">
      <ComponentMap data={resetPasswordData} setData={setResetPasswordData} />
      <div className="flex justify-between p-2 mt-2">
        <ThemedButton
          click={handleCancel}
          children={"Cancel"}
          theme={"warning"}
          id={"login_reset_cancel"}
        />
        <ThemedButton
          icon="custom"
          iconComponent={<LockResetIcon />}
          loading={auth.isAuthenticated === activityState.WAIT}
          click={handleResetPassword}
          valiData={resetPasswordData}
          change={setResetPasswordData}
          children={"Reset"}
          theme={"secondary"}
          id={"login_reset_button"}
        />
      </div>
    </div>
  );
};
